import React, { useEffect, useState } from "react";
import "./transferRequestDetails.css";

// components imports
import Loader from "../../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { updateTransferNotesRequest } from "../../../../../../services/WarehouseServices/warehouse.services";
// library imports
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { convertTime } from "../../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const TransferRequestDetails = ({
  open,
  setOpen,
  setSnack,
  setTransferNotes,
}) => {
  const { t } = useTranslation(["warehouse", "common"]);
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    status: "",
    description: "",
  });

  useEffect(() => {
    setFormData({
      status: open?.status,
      description: open.description,
    });
  }, [open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    setLoading(true);
    const response = await updateTransferNotesRequest(
      open?.id,
      formData?.status,
      formData?.description
    );
    setLoading(false);
    // console.log(response);
    if (!response?.data?.success) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("transferRequests.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setTransferNotes((prevData) => {
        return {
          ...prevData,
          data: prevData?.data?.map((data) => {
            return data?.id === open?.id ? response?.data?.result : data;
          }),
        };
      });

      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("transferRequests.statusUpdatedSuccessfully"),
          severity: "success",
        };
      });
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="transfer_note_details_modal_title"
        aria-describedby="transfer_note_details_modal_description"
      >
        <div className="details_container_modal">
          <h3 className="details_container_modal_title">
            {t("transferRequests.detailsFor", { reference: open?.reference_no ?? "-" })}
          </h3>

          <div className="details_container_modal_body">
            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">{t("transferRequests.dateColon")}</div>
              <div className="custabscreen__rdverttable_data">
                {convertTime(open?.created_at)}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferRequests.referenceNumberColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.reference_no ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferRequests.fromWarehouseColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.from_warehouse?.name ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferRequests.toWarehouseColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.to_warehouse?.name ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferRequests.createdByColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {user?.username ?? "-"}
              </div>
            </div>
          </div>
          <div className="transfer__request_statuschange_section">
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-label" size="small">
                {t("transferRequests.selectStatusRequired")}
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select-label"
                size="small"
                value={formData?.status || ""}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "status",
                      value: e.target.value,
                    },
                  })
                }
                label={t("transferRequests.selectStatus")}
              >
                <MenuItem value="pending">{t("transferRequests.pending")}</MenuItem>
                <MenuItem value="received">{t("transferRequests.received")}</MenuItem>
                <MenuItem value="notReceived">{t("transferRequests.notReceived")}</MenuItem>
              </Select>
            </FormControl>

            <div className="">
              <label className="edit__grn_byform_label">{t("transferRequests.note")}</label>
              <textarea
                className="edit__grn_byform_textarea"
                name="description"
                required
                value={formData?.description}
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
          <div className="details_container_modal_body">
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label={t("transferRequests.aDenseTable")}
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <strong>{t("transferRequests.productCode")}</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{t("transferRequests.name")}</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{t("transferRequests.quantity")}</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {open?.transfer_note_details?.map((transferDetail, index) => (
                    <>
                      <TableRow key={index}>
                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail?.id ?? "-"}
                        </TableCell>
                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail?.product?.full_name ?? "-"}
                        </TableCell>

                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail.quantity ?? "-"}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="transfer__request_modalfooter">
            <div
              className="transfer__request_modalreset"
              onClick={() => setOpen(false)}
            >
              {t("common:actions.close")}
            </div>
            <div className="admnedit__user_modalsave" onClick={handleUpdate}>
              {loading ? <Loader /> : t("transferRequests.update")}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TransferRequestDetails;
